import { FormEvent, ReactElement } from "react";

type HeaderProps = {
  onSubmit: () => void;
  children: ReactElement | ReactElement[];
};

export const Header = ({ onSubmit, children }: HeaderProps) => {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
};

  return (
    <form onSubmit={handleSubmit} id="questionnaire">
      {children}
    </form>
  );
};
